/**
 * Created by weicy on 16/12/5.
 * @author weicy
 * @filename email-autocomplete
 * @filetype {class}
 * @filedescription "邮箱自动补全组件"
 * @filereturn {function} Table "函数引用"
 */
define(function (require) {
  var cloud = require("cloud/base/cloud");
  require("cloud/resources/css/email-autocomplete.css");
  var autoComplete = Class.create(cloud.Component, {
    /**
     * init this component
     * @author weicy
     * @name initialize
     * @type {function}
     * @description "该类的实例化函数"
     * @param {function} $super "父类引用"
     * @param {object} options "json参数对象"
     */
    initialize: function ($super, options) {
      $super(options);
      this.elt = options.elt;
      this.data = options.data;
      this._render();
    },
    /**
     * render this component
     * @author weicy
     * @name _render
     * @type {method}
     * @description "渲染组件"
     * @private
     * @return
     */
    _render: function () {
      this.EmailAutoComplete();
    },
    EmailAutoComplete: function () {
      var elt = this.elt;
      var data = this.data;
      var strHtml = [];
      var tip;
      var lang = localStorage.getItem("language");
      strHtml.push('<div class="AutoComplete" id="AutoComplete">');
      strHtml.push('<ul class="AutoComplete_ul">');
      if (lang == "en") {
        tip = '<li class="AutoComplete_title">Please select a mailbox suffix</li>';
      } else if (lang == "zh_CN") {
        tip = '<li class="AutoComplete_title">请选择邮箱后缀</li>';
      }
      $("#lang-en").bind("click", function () {
        $('.AutoComplete_title').html('Please select a mailbox suffix');
      });
      $("#lang-zh").bind("click", function () {
        $('.AutoComplete_title').html('请选择邮箱后缀');
      });
      strHtml.push(tip);
      for (var i = 0; i < data.length; i++) {
        strHtml.push('<li hz="@' + data[i] + '"></li>');
      }
      strHtml.push('</ul>');
      strHtml.push('</div>');
      var autoComplete, autoLi;
      $('body').append(strHtml.join(''));
      autoComplete = $('#AutoComplete');
      autoComplete.data('elt', elt);
      autoLi = autoComplete.find('li:not(.AutoComplete_title)');
      autoLi.mouseover(function () {
        $(this).siblings().filter('.hover').removeClass('hover');
        $(this).addClass('hover');
      }).mouseout(function () {
        $(this).removeClass('hover');
      }).mousedown(function () {
        autoComplete.data('elt').val($(this).text()).change();
        autoComplete.hide();
      });
      //用户名补全+翻动
      elt.keyup(function (e) {
        if (/13|38|40|116/.test(e.keyCode) || this.value == '') {
          return false;
        }
        var username = this.value;
        if (username.indexOf('@') == -1) {
          autoComplete.hide();
          return false;
        }
        autoLi.each(function () {
          this.innerHTML = username.replace(/\@+.*/, '') + $(this).attr('hz');
          if (this.innerHTML.indexOf(username) >= 0) {
            $(this).show();
          } else {
            $(this).hide();
          }
        }).filter('.hover').removeClass('hover');
        autoComplete.show().css({
          left: $(this).offset().left,
          top: $(this).offset().top + $(this).outerHeight(true) - 1,
          position: 'absolute',
          zIndex: '99999'
        });
        if (autoLi.filter(':visible').length == 0) {
          autoComplete.hide();
        } else {
          autoLi.filter(':visible').eq(0).addClass('hover');
        }
      }).keydown(function (e) {
        if (e.keyCode == 38) { //上
          autoLi.filter('.hover').prev().not('.AutoComplete_title').addClass('hover').next().removeClass('hover');
        } else if (e.keyCode == 40) { //下
          autoLi.filter('.hover').next().addClass('hover').prev().removeClass('hover');
        } else if (e.keyCode == 13) { //Enter
          autoLi.filter('.hover').mousedown();
          e.preventDefault();    //如有表单，阻止表单提交
          e.stopPropagation();
        }
      }).focus(function () {
        var inputText = elt.val();
        if (inputText.length > 1 && inputText.split("@").length - 1 == 1) {
          autoComplete.show();
        }
        autoComplete.data('elt', $(this));

      }).blur(function () {
        autoComplete.hide();
      });
    }
  });
  return autoComplete;
});



//////////////////
// WEBPACK FOOTER
// ./cloud/components/email-autocomplete.js
// module id = 64
// module chunks = 0 49